"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils"); // Added extra questions (work-life balance related) & program evaluation.


var questions = screenersImport.expandscreeners([{
  prompt: "This questionnaire will measure your current stress and wellbeing levels, " + "and compare it against global averages. " + "We are committed to confidentiality and won't ever use your responses in a way that could identify you.",
  type: "multi",
  options: {
    options: [],
    reversed: false
  },
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, utils.screeners.PSS_DEPRECATED, utils.screeners.ROI_HPQ_3, utils.screeners.WHO5, utils.screeners.workplaceQuestionnaire5, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a great place to work?",
  extraText: "",
  type: "multi",
  options: ["0 - Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Extremely likely"],
  key: "npsWork",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // Work-life balance indicators
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "multi",
  options: ["0 - Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Best possible sleep"],
  key: "sleepQuality",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "How many hours did you work in the last week?",
  extraText: "",
  type: "multi",
  options: ["0-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90+"],
  key: "hoursWorkedLastWeek",
  eval: function _eval(n) {
    return 5 + 10 * n;
  },
  batteryId: "survey"
}, // Finally, we just need some information about your role.
// Again, we won't be sending anything to your employer that identifies you personally.
// We only send reports with data averages and never your individual responses.
{
  prompt: "What is your gender?",
  type: "multi",
  options: ["Male", "Female", "Other"],
  key: "gender",
  eval: function _eval(n) {
    return ["Male", "Female", "Other"][n];
  },
  batteryId: "survey"
}, {
  prompt: "How old are you?",
  type: "multi",
  options: ["0-25", "26-30", "31-35", "36-40", "41-45", "46-50", "51-55", "56-60", "61-65", "65+"],
  key: "age",
  eval: function _eval(n) {
    return ["0-25", "26-30", "31-35", "36-40", "41-45", "46-50", "51-55", "56-60", "61-65", "65+"][n];
  },
  batteryId: "survey"
}, {
  prompt: "What role / category of work best describes where you spend 70% or more of your time?",
  extraText: "(optional)",
  type: "single",
  optional: true,
  key: "jobTitle",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]);

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  [utils.screeners.PSS_DEPRECATED, utils.screeners.WHO5, utils.screeners.ROI_HPQ_3, utils.screeners.workplaceQuestionnaire5].forEach(function (battery) {
    results = Object.assign(results, screenersImport.extractResults(questions, answers, battery));
    var scales = screenersImport.getScalesByBatteryId(battery);

    if (scales) {
      results.scales = Object.assign(results.scales, scales);
    }

    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[i];
    } else {
      results[q.key] = q.eval(answers[i], q);
      results.humanReadable[q.prompt] = q.eval(answers[i], q);
    }
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};